import React from "react";
import CommonTopDetails from "../../../components/AdminComponents/CommonTopDetails";
import { Table } from "antd";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";
import CaSideNav from "../../../components/AdminComponents/CaSideNav";
import Sidebar from "../../../components/AdminComponents/SideNav";
import {
  CourseTopLevel,
  CourseTopLevelCA,
} from "../../../components/AdminComponents/MenuItems";
const CourseQuizListing = () => {
  const columns = [
    {
      title: "Quiz ID",
      dataIndex: "course_id",
      key: "course_id",
      width: 120,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: 180,
    },
    {
      title: "Course Name",
      dataIndex: "course_name",
      key: "course_name",
      width: 200,
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      width: 250,
      ellipsis: true,
    },
    {
      title: "Producer",
      dataIndex: "producer_name",
      key: "producer_name",
      width: 150,
    },
    {
      title: "Created Date",
      dataIndex: "created_at",
      key: "created_at",
      width: 150,
    },
    {
      title: "Updated Date",
      dataIndex: "updated_at",
      key: "updated_at",
      width: 150,
    },
  ];

  const data = [
    {
      key: "1",
      course_id: "QZ101",
      name: "JavaScript Basics",
      course_name: "Web Development 101",
      description: "A beginner-friendly quiz covering JS fundamentals.",
      producer_name: "John Doe",
      created_at: dayjs("2024-05-10").format("MMM DD YYYY"),
      updated_at: dayjs("2024-07-12").format("MMM DD YYYY"),
    },
    {
      key: "2",
      course_id: "QZ102",
      name: "React Advanced",
      course_name: "Frontend Mastery",
      description: "Deep dive into React hooks, context API, and performance.",
      producer_name: "Jane Smith",
      created_at: dayjs("2024-06-05").format("MMM DD YYYY"),
      updated_at: dayjs("2024-08-15").format("MMM DD YYYY"),
    },
    {
      key: "3",
      course_id: "QZ103",
      name: "Node.js Fundamentals",
      course_name: "Backend Essentials",
      description:
        "Covers Node.js basics including event loop and async programming.",
      producer_name: "Mike Johnson",
      created_at: dayjs("2024-04-22").format("MMM DD YYYY"),
      updated_at: dayjs("2024-07-01").format("MMM DD YYYY"),
    },
    {
      key: "4",
      course_id: "QZ104",
      name: "CSS Mastery",
      course_name: "UI/UX Design",
      description:
        "Quiz on advanced CSS concepts including flexbox, grid, and animations.",
      producer_name: "Alice Brown",
      created_at: dayjs("2024-05-18").format("MMM DD YYYY"),
      updated_at: dayjs("2024-06-20").format("MMM DD YYYY"),
    },
    {
      key: "5",
      course_id: "QZ105",
      name: "Data Structures",
      course_name: "Computer Science Basics",
      description:
        "Test knowledge on arrays, linked lists, stacks, queues, and trees.",
      producer_name: "Bob Williams",
      created_at: dayjs("2024-03-15").format("MMM DD YYYY"),
      updated_at: dayjs("2024-05-25").format("MMM DD YYYY"),
    },
    {
      key: "6",
      course_id: "QZ106",
      name: "Database Basics",
      course_name: "SQL Foundations",
      description: "Quiz about SQL queries, normalization, and indexing.",
      producer_name: "Clara Evans",
      created_at: dayjs("2024-02-12").format("MMM DD YYYY"),
      updated_at: dayjs("2024-04-18").format("MMM DD YYYY"),
    },
    {
      key: "7",
      course_id: "QZ107",
      name: "Cybersecurity Essentials",
      course_name: "IT Security",
      description:
        "Test your understanding of security principles and practices.",
      producer_name: "David Miller",
      created_at: dayjs("2024-01-08").format("MMM DD YYYY"),
      updated_at: dayjs("2024-06-11").format("MMM DD YYYY"),
    },
  ];
  const location = useLocation();
  const isCAAdmin = location.pathname.includes("ca-admin");
  const WrapperComponent = isCAAdmin ? CaSideNav : Sidebar;
  const wrapperProps = isCAAdmin ? CourseTopLevelCA : CourseTopLevel;
  return (
    <WrapperComponent props={wrapperProps}>
      <CommonTopDetails
        title={`Quiz Management`}
        titleSuffix={`${7 || 0} quiz(s)`}
        searchPlaceholder="Search by..."
        searchAction={() => {}}
        showAddButton={true}
        filterAction={false}
        // marginPass="15px"
        paddingInlinepass="10px"
        // topSizeAdd="5px"
        addButtonProps={{
          modalType: "Redirect",
          redirctlink: "/trainery-learn/quiz/add",
        }}
      />
      <Table
        columns={columns}
        dataSource={data}
        rowKey="id"
        size="small"
        loading={false}
        className="table-container"
        style={{ margin: "1rem" }}
        pagination={false}
        scroll={{
          x: 500,
        }}
        bordered
      />

      {/* <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          padding: "1rem",
        }}
      >
        <Pagination
          size="small"
          showSizeChanger
          onShowSizeChange={onShowSizeChange}
          onChange={onPageChange}
          pageSizeOptions={["5", "10", "15", "20", "50"]}
          //   showQuickJumper
          current={currentPage}
          defaultPageSize={pageSize}
          total={itemsLength}
        />
        </div> */}
    </WrapperComponent>
  );
};

export default CourseQuizListing;
